// extracted by mini-css-extract-plugin
module.exports = {"res":"CaruselPage_res__1hVNB"};